const STORAGE_KEY = 'dodsego-merch-cart-v1';

function normalizeVariantKey(selectedVariants) {
  if (!Array.isArray(selectedVariants) || selectedVariants.length === 0) return '';
  return selectedVariants
    .map((entry) => {
      const title = String(entry?.title || '').trim().toLowerCase();
      const value = String(entry?.value || '').trim().toLowerCase();
      return title && value ? `${title}:${value}` : '';
    })
    .filter(Boolean)
    .sort((a, b) => a.localeCompare(b))
    .join('|');
}

export function loadMerchCart() {
  if (typeof window === 'undefined') return [];
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function saveMerchCart(items) {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.isArray(items) ? items : []));
  } catch {
    // ignore storage failures
  }
}

export function cartCount(items) {
  return (Array.isArray(items) ? items : []).reduce((sum, item) => sum + Math.max(1, Number(item?.quantity || 1)), 0);
}

export function cartTotal(items) {
  return (Array.isArray(items) ? items : []).reduce((sum, item) => {
    const price = Math.max(0, Number(item?.salePriceNok || 0));
    const qty = Math.max(1, Number(item?.quantity || 1));
    return sum + (price * qty);
  }, 0);
}

export function addItemToCart(items, nextItem) {
  const current = Array.isArray(items) ? items : [];
  const productId = String(nextItem?.productId || '').trim();
  const size = String(nextItem?.requestedSize || '').trim().toUpperCase();
  const variantsKey = normalizeVariantKey(nextItem?.selectedVariants);
  const key = `${productId}::${size}::${variantsKey}`;

  const foundIndex = current.findIndex((item) => {
    const existingProductId = String(item?.productId || '').trim();
    const existingSize = String(item?.requestedSize || '').trim().toUpperCase();
    const existingVariantsKey = normalizeVariantKey(item?.selectedVariants);
    return `${existingProductId}::${existingSize}::${existingVariantsKey}` === key;
  });

  if (foundIndex === -1) {
    return [...current, { ...nextItem, quantity: Math.max(1, Number(nextItem?.quantity || 1)) }];
  }

  return current.map((item, index) => {
    if (index !== foundIndex) return item;
    const mergedQty = Math.max(1, Number(item.quantity || 1)) + Math.max(1, Number(nextItem?.quantity || 1));
    return { ...item, quantity: mergedQty };
  });
}
